import { useState } from 'react';
import { useEventReporter, useOverlayContext, useStoreActions } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { CopyToClipboard } from "../../../components/CopyToClipboard/CopyToClipboard";
import { useOnMount } from "../../../hooks/useOnMount";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import CopyAPIKeyModal from "../CopyAPIKeyModal/CopyAPIKeyModal";
import ZapierLogo from "./ZapierLogo";
import styles from "./ZapierCard.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ZapierCard() {
  const {
    api
  } = useStoreActions();
  const {
    reportToAppcues,
    reportToGtm,
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const {
    MANAGE_API_KEYS
  } = useFeatureFlags();
  const overlayContext = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const openIntegrateModal = () => {
    logBI(12050);
    reportToAppcues('button-click', "zapier-vendor-clicked-connect");
    reportToGtm('button-click', "zapier-vendor-clicked-connect");
    reportToHeap('integrations', 'click', "zapier-connect");
    reportToHubspot("vendor_clicked_connect_to_zapier");
    overlayContext.showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        const [apiKey, setApiKey] = useState('');
        const [helperText, setHelperText] = useState('');
        const steps = MANAGE_API_KEYS ? ['1. Copy the API key below', /*#__PURE__*/_jsx("div", {
          className: styles.copyApiKeyContainer,
          children: /*#__PURE__*/_jsx(CopyToClipboard, {
            "data-testid": "zapier-api-key",
            value: apiKey,
            helperText: helperText,
            error: !!helperText,
            onClick: () => {
              logBI(12051);
              reportToAppcues('button-click', "zapier-vendor-copied-api-key-to-clipboard");
              reportToGtm('button-click', "zapier-vendor-copied-api-key-to-clipboard");
              reportToHeap('integrations', 'click', "zapier-copy-api-key");
              reportToHubspot('vendor_copied_api_key_to_clipboard');
            }
          })
        }), '2. Login to your Zapier account, create a zap with Anchor and paste the API key'] : ['1. Copy the API key below', '2. Login to your Zapier account, create a zap with Anchor and paste the API key'];
        useOnMount(() => {
          if (MANAGE_API_KEYS) {
            api.zapier.getApiKey().then(setApiKey).catch(() => setHelperText('API key not found. Please try again later.'));
          }
        });
        return /*#__PURE__*/_jsx(CopyAPIKeyModal, {
          dismissModal: dismissModal,
          title: "Zapier",
          integrationUrl: "https://zapier.com/app/connections",
          testId: "zapier",
          steps: steps,
          getApiKey: () => api.zapier.getApiKey(),
          onCopyApiKey: () => {
            logBI(12051);
            reportToAppcues('button-click', "zapier-vendor-copied-api-key-to-clipboard");
            reportToGtm('button-click', "zapier-vendor-copied-api-key-to-clipboard");
            reportToHeap('integrations', 'click', "zapier-copy-api-key");
            reportToHubspot('vendor_copied_api_key_to_clipboard');
          }
        });
      }
    });
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "zapier-card",
    icon: /*#__PURE__*/_jsx(ZapierLogo, {}),
    title: "Zapier",
    subTitle: "Integrate Anchor with hundreds of other apps to automate your work",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: openIntegrateModal,
      "data-testid": "zapier-card-connect",
      children: "Connect"
    })
  });
}